module.exports = __webpack_public_path__ + "img/sorry.e2a91c23.jpg";